/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:19:58
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:45:29
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import HelpFaq from '@/components/Help/HelpFaq';

// CONTAINER ///////////////////////////////////////////////////////////////////
const Help = {
  components: { HelpFaq },
  store,
  computed: {
    ...mapGetters(['faqList']),
  },
  template: `
    <div class="container-fluid animated fadeIn">
      <div class="row">
        <div class="col-xs-12">
          <help-faq :faq-list="faqList"/>
        </div>
      </div>
    </div>
  `,
};

export default Vue
  .component('Help', Help);



// WEBPACK FOOTER //
// ./src/containers/Help/index.js